import React from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, PageHeader } from "../../components/v3";
import { ActionCard } from "../../components/report";
import { REPORT_ROUTES } from "../../pages/report/constants";
import { useHasPermission } from "../../utils";
import {
  GENERATE_ACCOUNT_REPORT,
  GENERATE_CLIENT_REPORT,
  GENERATE_MATERIAL_REPORT,
  // GENERATE_CRM_REPORT,
  GENERATE_DAILY_REPORT,
  // GENERATE_EMPLOYEE_REPORT,
  GENERATE_EXPENSE_REPORT,
  GENERATE_PROJECT_REPORT,
  // GENERATE_PURCHASE_REPORT,
  GENERATE_SUBCONTRACTOR_REPORT,
  // GENERATE_TOOL_REPORT,
  GENERATE_USER_REPORT,
  GENERATE_VENDOR_REPORT,
  GENERATE_WORKER_REPORT,
} from "../../constants";

export const Report = () => {
  const navigate = useNavigate();

  const hasDailyReport = useHasPermission(GENERATE_DAILY_REPORT);
  const hasCrmReport = false; // useHasPermission(GENERATE_CRM_REPORT);
  const hasProjectReport = useHasPermission(GENERATE_PROJECT_REPORT);
  const hasWorkerReport = useHasPermission(GENERATE_WORKER_REPORT);
  const hasVendorReport = useHasPermission(GENERATE_VENDOR_REPORT);
  const hasExpenseReport = useHasPermission(GENERATE_EXPENSE_REPORT);
  const hasSubcontractorReport = useHasPermission(GENERATE_SUBCONTRACTOR_REPORT);
  const hasClientReport = useHasPermission(GENERATE_CLIENT_REPORT);
  const hasEmployeeReport = false; // useHasPermission(GENERATE_EMPLOYEE_REPORT);
  const hasUserReport = useHasPermission(GENERATE_USER_REPORT);
  const hasMaterialReport = useHasPermission(GENERATE_MATERIAL_REPORT);
  const hasAccountReport = useHasPermission(GENERATE_ACCOUNT_REPORT);
  const hasToolReport = false; // useHasPermission(GENERATE_TOOL_REPORT);

  const handleViewClick = (data) => {
    switch (data?.id) {
      case "daily-report":
        navigate("/reports/daily");
        break;
      case "crm-report":
        navigate("/reports/crm");
        break;
      case "project-report":
        navigate("/reports/project");
        break;
      case "worker-report":
        navigate("/reports/worker");
        break;
      case "vendor-report":
        navigate("/reports/vendor");
        break;
      case "expense-report":
        navigate("/reports/expense");
        break;
      case "subcontractor-report":
        navigate("/reports/subcontractor");
        break;
      case "client-report":
        navigate("/reports/client");
        break;
      case "employee-report":
        navigate("/reports/employee");
        break;
      case "user-report":
        navigate("/reports/user");
        break;
      case "material-report":
        navigate("/reports/material");
        break;
      case "account-report":
        navigate("/reports/account");
        break;
      case "tool-report":
        navigate("/reports/tool");
        break;
      default:
        navigate(REPORT_ROUTES.root);
        break;
    }
  };

  const reportData = [
    { id: "daily-report", icon: "today", name: "Daily Report", hasViewButton: hasDailyReport },
    { id: "crm-report", icon: "today", name: "CRM Report", hasViewButton: hasCrmReport },
    { id: "project-report", icon: "business_center", name: "Project Report", hasViewButton: hasProjectReport },
    { id: "worker-report", icon: "engineering", name: "Worker Report", hasViewButton: hasWorkerReport },
    { id: "vendor-report", icon: "store", name: "Vendor Report", hasViewButton: hasVendorReport },
    { id: "expense-report", icon: "receipt_long", name: "Expense Report", hasViewButton: hasExpenseReport },
    { id: "subcontractor-report", icon: "handyman", name: "Subcontractor Report", hasViewButton: hasSubcontractorReport },
    { id: "client-report", icon: "groups", name: "Client Report", hasViewButton: hasClientReport },
    { id: "employee-report", icon: "badge", name: "Employee Report", hasViewButton: hasEmployeeReport },
    { id: "user-report", icon: "badge", name: "User Report", hasViewButton: hasUserReport },
    { id: "material-report", icon: "inventory", name: "Material Report", hasViewButton: hasMaterialReport },
    { id: "account-report", icon: "account_balance", name: "Account Report", hasViewButton: hasAccountReport },
    { id: "tool-report", icon: "inventory", name: "Tool Report", hasViewButton: hasToolReport },
  ];

  // control number of cards per row
  const cardsPerRow = 3;

  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="Reports" />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <CardLayout>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              gap: 2,
              width: "100%",
            }}
          >
            {reportData
              .filter((item) => item.hasViewButton)
              .map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: `0 0 calc(${100 / cardsPerRow}% - 16px)`,
                    boxSizing: "border-box",
                    "@media (max-width: 900px)": {
                      flex: "0 0 calc(50% - 16px)",
                    },
                    "@media (max-width: 600px)": {
                      flex: "0 0 100%",
                    },
                  }}
                >
                  <ActionCard data={item} {...item} showAlert onViewClick={handleViewClick} />
                </Box>
              ))}
          </Box>
        </CardLayout>
      </Box>
    </PageLayout>
  );
};
